(function () {
  'use strict';

  /* =========================================================
     MAYORISTA ANTUPIRÉN
     PRECIOS DINÁMICOS POR FORMATO
     Versión resistente a re-render de Shopify Refresh
     ========================================================= */


  /* ---------------------------------------------------------
     FORMATO CLP
     Shopify entrega precios en centavos.
     --------------------------------------------------------- */

  function formatCLP(cents) {
    var value = Number(cents || 0);

    if (!Number.isFinite(value)) {
      value = 0;
    }

    var pesos = Math.round(value / 100);

    return '$' + pesos.toLocaleString('es-CL');
  }


  /* ---------------------------------------------------------
     NORMALIZAR TEXTO
     --------------------------------------------------------- */

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }


  /* ---------------------------------------------------------
     OBTENER UNIDADES DEL FORMATO

     Prioridad:
     1. custom.unidades_pack
     2. número dentro del nombre

     Ejemplos:
     1 BANDEJA       => 1
     3 BANDEJAS      => 3
     12 UNIDADES     => 12
     24 UNIDADES [...] => 24
     --------------------------------------------------------- */

  function getUnits(variant, formatValue) {
    var metafieldUnits = Number(variant && variant.units);

    if (
      Number.isFinite(metafieldUnits) &&
      metafieldUnits > 0
    ) {
      /*
       * Si el metafield realmente tiene información útil,
       * se utiliza.
       */
      if (metafieldUnits !== 1) {
        return metafieldUnits;
      }
    }

    var text = String(formatValue || '');

    var match = text.match(/\d+/);

    if (match) {
      var parsed = Number(match[0]);

      if (
        Number.isFinite(parsed) &&
        parsed > 0
      ) {
        return parsed;
      }
    }

    if (
      Number.isFinite(metafieldUnits) &&
      metafieldUnits > 0
    ) {
      return metafieldUnits;
    }

    return 1;
  }


  /* ---------------------------------------------------------
     LEER JSON DE VARIANTES

     Se lee nuevamente cada vez.
     Esto es importante porque Shopify Refresh puede
     reemplazar el contenido dinámicamente.
     --------------------------------------------------------- */

  function getVariants(root) {
    var jsonNode = root.querySelector(
      '[data-antu-variants]'
    );

    if (!jsonNode) {
      return [];
    }

    try {
      var parsed = JSON.parse(
        jsonNode.textContent
      );

      return Array.isArray(parsed)
        ? parsed
        : [];
    } catch (error) {
      console.error(
        'Antupirén: no se pudieron leer las variantes.',
        error
      );

      return [];
    }
  }


  /* ---------------------------------------------------------
     OBTENER TODAS LAS OPCIONES SELECCIONADAS
     --------------------------------------------------------- */

  function getSelectedOptions(root) {
    var selected = [];

    /*
     * Radios:
     * Formato
     * Tipo
     * Sabor
     * etc.
     */
    var groups = root.querySelectorAll(
      '.product-form__input--pill, .product-form__input--swatch'
    );

    groups.forEach(function (group) {
      var checked = group.querySelector(
        'input[type="radio"]:checked'
      );

      if (!checked) {
        return;
      }

      var position = Number(
        checked.dataset.optionPosition ||
        group.dataset.optionPosition ||
        0
      );

      selected.push({
        position: position,
        value: checked.value,
        isFormat: group.classList.contains(
          'antu-format-picker'
        )
      });
    });


    /*
     * Dropdowns.
     */
    var dropdowns = root.querySelectorAll(
      '.product-form__input--dropdown select'
    );

    dropdowns.forEach(function (select) {
      var position = Number(
        select.dataset.optionPosition || 0
      );

      selected.push({
        position: position,
        value: select.value,
        isFormat: false
      });
    });


    return selected;
  }


  /* ---------------------------------------------------------
     ENCONTRAR VARIANTE CORRECTA PARA CADA FORMATO

     Ejemplo:

     estamos viendo:
     3 BANDEJAS

     actualmente seleccionado:
     Crema Pastelera

     buscamos:
     3 BANDEJAS + Crema Pastelera
     --------------------------------------------------------- */

  function findVariantForFormat(
    root,
    variants,
    formatValue
  ) {
    var selectedOptions =
      getSelectedOptions(root);

    return variants.find(function (variant) {
      if (
        !variant ||
        !Array.isArray(variant.options)
      ) {
        return false;
      }

      /*
       * Comprobar que una de las opciones
       * corresponda al formato que estamos evaluando.
       */

      var containsFormat =
        variant.options.some(function (value) {
          return (
            normalize(value) ===
            normalize(formatValue)
          );
        });

      if (!containsFormat) {
        return false;
      }


      /*
       * Comparar el resto de opciones:
       * sabor, color, tipo, etc.
       */

      for (
        var i = 0;
        i < selectedOptions.length;
        i++
      ) {
        var selected =
          selectedOptions[i];

        /*
         * El formato se ignora aquí,
         * porque estamos comparando todas
         * sus alternativas.
         */
        if (selected.isFormat) {
          continue;
        }

        if (!selected.position) {
          continue;
        }

        var index =
          selected.position - 1;

        if (
          normalize(variant.options[index]) !==
          normalize(selected.value)
        ) {
          return false;
        }
      }

      return true;
    });
  }


  /* ---------------------------------------------------------
     LIMPIAR TARJETA CUANDO NO HAY VARIANTE
     --------------------------------------------------------- */

  function clearCard(card) {
    var unitNode =
      card.querySelector(
        '.antu-format-unit-price'
      );

    var totalNode =
      card.querySelector(
        '.antu-format-total-price'
      );

    var saveNode =
      card.querySelector(
        '.antu-format-save'
      );

    if (unitNode) {
      unitNode.textContent = '—';
    }

    if (totalNode) {
      totalNode.textContent = '—';
    }

    if (saveNode) {
      saveNode.textContent = '';
    }

    delete card.dataset.unitPrice;
    delete card.dataset.totalPrice;
    delete card.dataset.units;
  }


  /* ---------------------------------------------------------
     ACTUALIZAR UN SELECTOR COMPLETO
     --------------------------------------------------------- */

  function updateRoot(root) {
    if (!root) {
      return;
    }

    var formatPicker =
      root.querySelector(
        '.antu-format-picker'
      );

    if (!formatPicker) {
      return;
    }

    var variants =
      getVariants(root);

    if (!variants.length) {
      return;
    }

    var cards =
      formatPicker.querySelectorAll(
        '.antu-format-option'
      );

    if (!cards.length) {
      return;
    }

    var data = [];


    /* ======================================================
       1. CALCULAR PRECIO DE CADA FORMATO
       ====================================================== */

    cards.forEach(function (card) {
      var formatValue =
        card.dataset.formatValue;

      if (!formatValue) {
        clearCard(card);
        return;
      }

      var variant =
        findVariantForFormat(
          root,
          variants,
          formatValue
        );

      if (!variant) {
        clearCard(card);

        data.push({
          card: card,
          valid: false
        });

        return;
      }

      var units =
        getUnits(
          variant,
          formatValue
        );

      var totalPrice =
        Number(variant.price || 0);

      if (
        !Number.isFinite(totalPrice) ||
        totalPrice <= 0
      ) {
        clearCard(card);

        data.push({
          card: card,
          valid: false
        });

        return;
      }

      var unitPrice =
        Math.round(
          totalPrice / units
        );


      /*
       * Guardamos valores también
       * en dataset por si después
       * necesitamos utilizarlos.
       */

      card.dataset.units =
        String(units);

      card.dataset.unitPrice =
        String(unitPrice);

      card.dataset.totalPrice =
        String(totalPrice);


      var unitNode =
        card.querySelector(
          '.antu-format-unit-price'
        );

      var totalNode =
        card.querySelector(
          '.antu-format-total-price'
        );


      if (unitNode) {
        unitNode.textContent =
          formatCLP(unitPrice) +
          ' c/u';
      }


      if (totalNode) {
        totalNode.textContent =
          formatCLP(totalPrice) +
          ' total';
      }


      data.push({
        card: card,
        valid: true,
        variant: variant,
        units: units,
        unitPrice: unitPrice,
        totalPrice: totalPrice
      });
    });


    /* ======================================================
       2. IDENTIFICAR PRECIO NORMAL

       Preferimos el formato con 1 unidad.

       Si no existe, usamos el formato
       con menor cantidad.
       ====================================================== */

    var validData =
      data.filter(function (item) {
        return item.valid;
      });


    if (!validData.length) {
      return;
    }


    var base =
      validData.find(function (item) {
        return item.units === 1;
      });


    if (!base) {
      validData.sort(function (a, b) {
        return a.units - b.units;
      });

      base = validData[0];
    }


    var baseUnitPrice =
      base.unitPrice;


    /* ======================================================
       3. AHORRO

       IMPORTANTE:
       nunca mostramos ahorro en formato base.
       ====================================================== */

    validData.forEach(function (item) {
      var saveNode =
        item.card.querySelector(
          '.antu-format-save'
        );

      if (!saveNode) {
        return;
      }


      /*
       * Formato normal.
       */
      if (
        item.units <= base.units
      ) {
        saveNode.textContent = '';
        return;
      }


      /*
       * Precio que costaría comprar las mismas
       * unidades al valor normal.
       */
      var theoreticalTotal =
        baseUnitPrice *
        item.units;


      var saving =
        theoreticalTotal -
        item.totalPrice;


      if (saving > 0) {
        saveNode.textContent =
          'Ahorras ' +
          formatCLP(saving);
      } else {
        saveNode.textContent = '';
      }
    });
  }


  /* ---------------------------------------------------------
     ACTUALIZAR TODOS LOS PRODUCTOS PRESENTES
     --------------------------------------------------------- */

  function updateAll() {
    document
      .querySelectorAll('variant-selects')
      .forEach(function (root) {
        updateRoot(root);
      });
  }


  /* ---------------------------------------------------------
     ACTUALIZACIÓN PROGRAMADA

     Evita ejecutar el cálculo muchas veces
     seguidas mientras Shopify cambia HTML.
     --------------------------------------------------------- */

  var updateTimer = null;

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);

    updateTimer =
      window.setTimeout(
        updateAll,
        typeof delay === 'number'
          ? delay
          : 40
      );
  }


  /* =========================================================
     EVENTOS

     Usamos delegación sobre document.
     Así funciona aunque Shopify destruya y vuelva
     a crear los selectores.
     ========================================================= */

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (!target) {
        return;
      }

      if (
        target.matches(
          'variant-selects input[type="radio"], variant-selects select'
        )
      ) {
        /*
         * Primer cálculo rápido.
         */
        scheduleUpdate(30);

        /*
         * Segundo cálculo después de que Refresh
         * termine de reemplazar su HTML.
         */
        window.setTimeout(
          updateAll,
          180
        );

        /*
         * Y uno final para conexiones lentas/
         * render asíncrono.
         */
        window.setTimeout(
          updateAll,
          450
        );
      }
    }
  );


  /* =========================================================
     MUTATION OBSERVER

     Este es el cambio más importante.

     Si Shopify reemplaza la ficha o las variantes,
     automáticamente volvemos a calcular precios.
     ========================================================= */

  var observer =
    new MutationObserver(function (mutations) {
      var relevant = false;

      for (
        var i = 0;
        i < mutations.length;
        i++
      ) {
        if (
          mutations[i].addedNodes &&
          mutations[i].addedNodes.length
        ) {
          relevant = true;
          break;
        }
      }

      if (relevant) {
        scheduleUpdate(60);
      }
    });


  function startObserver() {
    if (!document.body) {
      return;
    }

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /* ---------------------------------------------------------
     SHOPIFY THEME EDITOR
     --------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleUpdate(50);
    }
  );


  document.addEventListener(
    'shopify:section:select',
    function () {
      scheduleUpdate(50);
    }
  );


  /* ---------------------------------------------------------
     PAGESHOW

     Importante para Safari/iPhone cuando vuelve
     desde otra página usando caché.
     --------------------------------------------------------- */

  window.addEventListener(
    'pageshow',
    function () {
      scheduleUpdate(50);
    }
  );


  /* ---------------------------------------------------------
     INICIO
     --------------------------------------------------------- */

  function init() {
    startObserver();

    updateAll();

    window.setTimeout(
      updateAll,
      250
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();